export enum VoucherRevokeType {
  Standard = "STANDARD",
  Voucher = "VOUCHER",
}
